<template>
    <div class="search-bar">

        <!-- search query -->
        <v-text-field 
            clearable 
            hide-details 
            label="search your library" 
            elevation="0"
            variant="solo"
            color="color1"
            class="query" 
            :class="{'highlight': hasSearchQuery}" 
            v-model="searchQuery">
        </v-text-field>

        <!-- sorting -->
        <div class="sorting">

            <span class="sorting-label">sort by</span>

            <!-- sorting type: date or ratings -->
            <v-btn-toggle
                mandatory 
                color="color1" 
                class="toggle" 
                elevation="0" 
                density="default"
                v-model="sortingType">

                <v-btn 
                    class="toggle-button" 
                    :value="keySortTypeDate">
                    <v-tooltip
                        activator="parent"
                        location="bottom">
                        sort by date
                    </v-tooltip>   
                    <v-icon 
                        icon="fa-solid fa-calendar">
                    </v-icon>
                    <span class="hide-on-mobile">&nbsp;date</span>
                </v-btn>

                <v-btn 
                    class="toggle-button" 
                    :value="keySortTypeRating">
                    <v-tooltip
                        activator="parent"
                        location="bottom">
                        sort by rating
                    </v-tooltip>   
                    <v-icon 
                        icon="fa-solid fa-star">
                    </v-icon>
                    <span class="hide-on-mobile">&nbsp;rating</span>
                </v-btn>
            </v-btn-toggle>

            <!-- sorting order: ascending or descending -->
            <v-btn-toggle 
                mandatory 
                color="color1" 
                class="toggle" 
                elevation="0" 
                density="default"
                v-model="sortingOrder">

                <v-btn 
                    class="toggle-button" 
                    :value="keySortOrderDescending">
                    <v-tooltip
                        activator="parent"
                        location="bottom">
                        sort in descending order
                    </v-tooltip>   
                    <v-icon icon="fa-solid fa-arrow-down-wide-short"></v-icon>
                </v-btn>

                <v-btn 
                    class="toggle-button" 
                    :value="keySortOrderAscending">
                    <v-tooltip
                        activator="parent"
                        location="bottom">
                        sort in ascending order
                    </v-tooltip>   
                    <v-icon icon="fa-solid fa-arrow-up-wide-short"></v-icon>
                </v-btn>
            </v-btn-toggle>
        </div>

    </div>
</template>

<script>
import { mapGetters, mapActions } from '@generio-ai/library-legacy/plugins/vuex'

export default {
    name: 'BarSearch',
    computed: {
        ...mapGetters('library', [
            'keySortTypeDate',
            'keySortTypeRating',
            'keySortOrderAscending',
            'keySortOrderDescending',
            'hasSearchQuery',
            'getSearchQuery',
            'getSortingType',
            'getSortingOrder'
        ]),
        searchQuery: {
            get() {
                return this.getSearchQuery
            },
            set(value) {
                this.setSearchQuery(value)
            }
        },
        sortingType: {
            get() {
                return this.getSortingType
            },
            set(value) {
                this.setSortingType(value)
            }
        },
        sortingOrder: {
            get() {
                return this.getSortingOrder
            },
            set(value) {
                this.setSortingOrder(value)
            }
        },
    },
    methods: {
        ...mapActions('library', [
            'setSearchQuery',
            'setSortingType',
            'setSortingOrder'
        ])
    }
}
</script>

<style>
.search-bar .query .v-field {
    background-color: rgb(var(--v-theme-darkerbase)) !important;
    box-shadow: none !important;
    border: 1px solid rgb(var(--v-theme-lightbase)) !important;
}

.search-bar .v-btn {
    color: rgb(var(--v-theme-primary)) !important;
    background-color: rgb(var(--v-theme-darkbase)) !important;
}

.search-bar .v-btn:hover {
    background-color: rgba(var(--v-theme-lightbase), 0.3) !important;
}

.search-bar .v-btn--active {
    background-color: rgba(var(--v-theme-darkbase), 1.0) !important;
}
</style>

<style scoped>
.search-bar {
    flex-shrink: 1;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    padding: 10px;
    gap: 20px;
    background: linear-gradient(to bottom, rgb(var(--v-theme-darkbase)), rgba(var(--v-theme-darkerbase), 0.2));
    border-bottom: 1px solid rgb(var(--v-theme-lightbase));
}

.search-bar .query {
    flex: 1;
    opacity: 1;
}

.search-bar .query.highlight {
    opacity: 1;
}

.search-bar .toggle {
    max-width: 240px;
    border: 1px solid rgb(var(--v-theme-lightbase));
}

.search-bar .toggle-button {
    border-radius: 0px !important;
}

.search-bar .sorting {
    flex-shrink: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 20px;
}

.search-bar .sorting-label {
    color: rgb(var(--v-theme-secondary));
}

@media (max-width: 800px)
{
    .hide-on-mobile {
        display: none;
    }

    .search-bar {
        flex-direction: column;
    }

    .search-bar .sorting {
        display: none;
    }
}
</style>